/* LEDFROST — product header: model switch, gallery, pack variants */
(function () {
  'use strict';
  var root = document.querySelector('[data-lf-pdp]');
  if (!root) return;
  var atc = root.querySelector('[data-lf-atc]');

  function activeVar() { return root.querySelector('.lf-var:not([hidden])'); }

  function paint(v) {
    if (!v) return;
    var b = v.querySelector('[data-packs] .is-on') || v.querySelector('[data-packs] [data-vid]');
    if (!b) return;
    var c = b.getAttribute('data-c') || '';
    var pct = parseInt(b.getAttribute('data-pct'), 10);
    if (!c || !pct || pct < 1) pct = 0;
    var out = v.querySelector('[data-price]');
    if (out) {
      var eb = out.querySelector('b'), es = out.querySelector('s'), ei = out.querySelector('i');
      if (eb) eb.textContent = b.getAttribute('data-p') || '';
      if (es) { es.textContent = c; es.hidden = !c; }
      if (ei) { ei.textContent = pct ? ('−' + pct + ' %') : ''; ei.hidden = !pct; }
    }
    if (atc) {
      atc.setAttribute('data-lf-add', b.getAttribute('data-vid') || '0');
      atc.setAttribute('data-qty', '1');
      atc.setAttribute('data-url', b.getAttribute('data-url') || '/collections/all');
    }
    var sp = document.querySelector('[data-lf-stickyprice]');
    if (sp) {
      var sb = sp.querySelector('b'), ss = sp.querySelector('s');
      if (sb) sb.textContent = b.getAttribute('data-p') || '';
      if (ss) { ss.textContent = c; ss.hidden = !c; }
    }
  }

  function setModel(key) {
    root.querySelectorAll('[data-model]').forEach(function (b) {
      var on = b.getAttribute('data-model') === key;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
    });
    root.querySelectorAll('[data-gal]').forEach(function (g) { g.hidden = g.getAttribute('data-gal') !== key; });
    root.querySelectorAll('[data-var]').forEach(function (v) { v.hidden = v.getAttribute('data-var') !== key; });
    paint(activeVar());
  }

  root.querySelectorAll('[data-model]').forEach(function (b) {
    b.addEventListener('click', function () { setModel(b.getAttribute('data-model')); });
  });

  root.querySelectorAll('[data-packs]').forEach(function (wrap) {
    var btns = wrap.querySelectorAll('[data-vid]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.classList.toggle('is-on', x === b); });
        var v = wrap.closest('.lf-var');
        if (v && !v.hidden) paint(v);
      });
    });
  });

  root.querySelectorAll('[data-gal]').forEach(function (g) {
    var main = g.querySelector('[data-gal-main]');
    var ths = g.querySelectorAll('[data-th]');
    ths.forEach(function (t) {
      t.addEventListener('click', function () {
        ths.forEach(function (x) { x.setAttribute('aria-pressed', String(x === t)); });
        if (main) main.src = t.getAttribute('data-th');
      });
    });
    g.querySelectorAll('[data-gal-nav]').forEach(function (n) {
      n.addEventListener('click', function () {
        var arr = Array.prototype.slice.call(ths);
        if (!arr.length) return;
        var i = 0;
        arr.forEach(function (x, k) { if (x.getAttribute('aria-pressed') === 'true') i = k; });
        var d = parseInt(n.getAttribute('data-gal-nav'), 10) || 1;
        arr[(i + d + arr.length) % arr.length].click();
      });
    });
  });

  var first = root.querySelector('[data-model]');
  if (first) setModel(first.getAttribute('data-model'));
})();
